import React, { forwardRef, useState, useImperativeHandle } from "react";
import styles from "./tooltip.module.css";

const Tooltip = forwardRef((props, ref) => {
  const [active, setActive] = useState(false);
  const [selected, setSelected] = useState({ country: "" });
  const [tooltipStyle, setTooltipStyle] = useState({
    left: 0,
    top: 0,
    opacity: 0,
  });

  const handleMouseOver = (d, dx, dy, xOffset, yOffset, chartWidth, end) => {
    setActive(true);
    if (end) {
      setTooltipStyle({
        right: `${chartWidth - (dx - xOffset)}px`,
        top: `${dy + yOffset}px`,
      });
    } else {
      setTooltipStyle({
        left: `${dx + xOffset}px`,
        top: `${dy + yOffset}px`,
      });
    }
    setSelected(d);
  };

  const handleMouseOut = () => {
    setActive(false);
  };

  useImperativeHandle(ref, () => {
    return {
      handleMouseOver: handleMouseOver,
      handleMouseOut: handleMouseOut,
    };
  });

  return (
    <div
      className={`${styles.tooltip} ${active ? styles.active : ""}`}
      style={tooltipStyle}
    >
      <>
        <div>{selected.Site}</div>
        <div className="tooltip-country">{`${props.tooltipNumber} ${
          selected.Rank
        } ${props.tooltipIn} ${props.translationsMap[selected.Country]}`}</div>
      </>
    </div>
  );
});

export default Tooltip;
